export enum IS32AccordionType {
  RoomUnit = 'RoomUnit',
  General = 'General',
  Acoustic = 'Acoustic',
  Buttons = 'Buttons',
  Locations = 'Locations',
  LocalbusUnits = 'LocalbusUnits',
}
